import { TEXT_SELECTORS } from './Selectors'
import ToolConfig from '../types/ToolConfig'

export interface Filters {
  [key: string]: ToolConfig
}

export const FILTERS: Filters = {
  'dark-contrast': {
    styles: {
      color: '#FFF',
      fill: '#FFF',
      'background-color': '#000',
    },
    childrenSelector: TEXT_SELECTORS,
    css: 'html.asw-filter img[alt="Rumah Pendidikan"]{filter:brightness(0) invert(1) !important; background-color:unset !important; } html.asw-filter [aria-label^="Bagikan di"] img{filter:brightness(0) invert(1) !important; background-color:unset !important; } html.asw-filter .embla__dots button.bg-interactive-default{background:#FFF!important; border:1px solid #000!important;}',
  },
  'light-contrast': {
    styles: {
      color: '#000',
      fill: '#000',
      'background-color': '#FFF',
    },
    childrenSelector: TEXT_SELECTORS,
  },
  'high-contrast': {
    styles: {
      filter: 'contrast(125%)',
    },
  },
  'high-saturation': {
    styles: {
      filter: 'saturate(200%)',
    },
  },
  'low-saturation': {
    styles: {
      filter: 'saturate(50%)',
    },
  },
  monochrome: {
    styles: {
      filter: 'grayscale(100%)',
    },
  },
}

export default FILTERS
